@let blok = block();
@let image = imageBlok();
@if (!tariff.isTariffRoute$()) {
    <div
         [ngClass]="getAllClasses()"
         [lazyBgDirective]="blok.backgroundImage && blok.backgroundImage[0] ? blok.backgroundImage![0]!.filename: ''"
         class="w-full text-primary-contrast px-5"
         id="footer">
        <div class="max-w-content-width mx-auto">

            @if (image) {
                <s1-image class="footer__logo" [block]="image" />
            }
            <div class="grid gap-5 md:grid-cols-3">
                <div class="mb-6">
                    @for (child of blok.children1; track child['_uid']) {
                        <s1-cms-component [blok]="child" />
                    }
                </div>
                <div class="mb-6">
                    @for (child of blok.children2; track child['_uid']) {
                        <s1-cms-component [blok]="child" />
                    }
                </div>
                <div class="mb-6">
                    @for (child of blok.children3; track child['_uid']) {
                        <s1-cms-component [blok]="child" />
                    }
                </div>
                <div class="md:row-start-2 md:col-start-3 mb-6">
                    @for (child of blok.children4; track child['_uid']) {
                        <s1-cms-component [blok]="child" />
                    }
                </div>
                <div class="md:row-start-2 md:col-start-1 mb-6">
                    @for (child of blok.children5; track child['_uid']) {
                        <s1-cms-component [blok]="child" />
                    }
                </div>
                <!-- Impressum / Datenschutz -->
                <div class="mb-6">
                    @for (child of blok.children6; track child['_uid']) {
                        <s1-cms-component [blok]="child" />
                    }
                </div>
            </div>
        </div>
    </div>
}

